export default function Header({ text }: header) {
  return <p className={`text-header font-header text-gray-900`}>{text}</p>;
}

type header = {
  text: string;
  bold?: boolean;
};
